import { get, post, login as loginRequest, logout as logoutRequest, getToken as _getToken } from './fetch';

export const login = (email, password) => {
  return loginRequest({ email, password });
}

export const validateManagerAuthorization = () => {
  return post('/api/manager/authorization/validate', {}, true);
}

export const logout = () => {
  logoutRequest();
}

export const changePassword = ({ existingPassword, password, confirmPassword }) => {
  return post('/api/password/change', { existingPassword, password, confirmPassword });
}

export const resetPasswordRequest = (email) => {
  return post('/api/password/reset/request', { email, isBuyer: true }, false);
}

export const resetPassword = (hash, params) => {
  return post(`/api/password/${hash}/reset`, params, false);
}

export const isValidResetPasswordRequest = (hash) => {
  return get(`/api/password/reset/request/${hash}/is-valid`, false);
}

export const userContext = () => {
  return get('/api/user/context');
}

export const managerContext = () => {
  return get('/api/manager/context');
}

// export const allowMessengerCheck = () => {
//   return get(`/api/manager/check/allow-messenger`);
// }

export const contactUsSubmit = ({ subject, message, email }) => {
  const modifiedSubject = window.location.host + ' [Contact Us] ' + subject
  return post('/api/contact-us', { subject: modifiedSubject, message, email }, false);
}

export const getToken = () => {
  return _getToken();
}

export const getUser = () => {
  const user = {
    firstName: 'Ali',
    lastName: 'Raza',
    businessName: 'HighCare',
    businessType: 'Vehicle Services',
    address: 'Downtown, 324',
    city: 'Newark',
    state: 2,
    zip: '13433',
    services: [2, 3]
  };
  return Promise.resolve(user);
}

export const updateProfile = (profie) => {
  return Promise.resolve()
}

export const verifyEmail = (email) => {
  return post('/api/VerifyEmail', { email }, false);
}